import { render, staticRenderFns } from "./UISelect.vue?vue&type=template&id=a0ef01f4&"
import script from "./UISelect.vue?vue&type=script&lang=js&"
export * from "./UISelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports